import React, { useState, useEffect } from 'react';
import { Button, Dialog, Tooltip, DialogActions, DialogContent, DialogTitle, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Grid, TextField } from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/People';
import { permissionCheckFn } from '../../../utils';
import { PageLoader } from '../../../shared_elements';
import { titanAviInstance } from '../../../shared_elements/components';

const ApproveUserModal = ({ userArray, item, pageTitle, hasApproved }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [modal, setModal] = useState(false);
    const [pageLoader, setPageLoader] = useState()
    const [filteredUsers, setFilteredUsers] = useState(userArray);

    useEffect(() => {
        const newFilteredUsers = userArray?.filter(user =>
            user?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
            user?.email?.toLowerCase()?.includes(searchTerm.toLowerCase())
        );
        setFilteredUsers(newFilteredUsers);
    }, [searchTerm, userArray]);

    const handleSearchInputChange = (event) => {
        setSearchTerm(event.target.value);
    };
    return (
        <>
            <Tooltip title="Recipient User(s)" arrow>
                <PeopleIcon
                    className={` ${permissionCheckFn({ secondaryKey: 'event_history', keyIndex: 'U' }) && item.status && [0, 1, 2].includes(item.status.value) ? `${pageTitle == "Claim" ? hasApproved ? "timeline-people-claim-r-40" : "timeline-people-claim" : "timeline-people"}` : `${pageTitle == "Claim" ? "timeline-people-claim-r-40" : "timeline-people-r-40"}`}`}
                    color="primary"
                    onClick={() => setModal(true)}
                />
            </Tooltip>
            {pageLoader ? <PageLoader /> :
                <Dialog
                    open={modal}
                    onClose={() => setModal(false)}
                    aria-labelledby="scroll-dialog-title"
                    maxWidth="xs"
                    fullWidth
                    className="verify-amount-modal assign-user-modal"
                >
                    <DialogTitle id="scroll-dialog-title">{`Recipient User(s)`} </DialogTitle>
                    <DialogContent dividers={true} style={{ maxHeight: "402px", height: "500px", overflowY: "none" }}>
                        <TableContainer style={{ maxHeight: "400px", overflowY: "auto", scrollbarWidth: "none", }}>
                            <div className='search-section'>
                                <Grid item xs={12} >
                                    <TextField
                                        label="Search User"
                                        fullWidth
                                        margin="normal"
                                        value={searchTerm}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleSearchInputChange}
                                        variant='outlined'
                                        placeholder='Search by name..'
                                    />
                                </Grid></div>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>User(s)</TableCell>
                                        <TableCell>Email</TableCell>
                                        {titanAviInstance?  <TableCell>Approval Status</TableCell> :null }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredUsers?.length && !pageLoader ? (
                                        filteredUsers?.map((item, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell>{item?.name || ''} </TableCell>
                                                <TableCell>{item?.email || ''} </TableCell>
                                                {titanAviInstance &&  <TableCell>{item?.approved_status?.label || ''} </TableCell>}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={titanAviInstance ? 3 : 2} align="center">
                                                No User(s) Found
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <div>
                            <div style={{ float: 'right' }}>
                                <Button onClick={() => setModal(false)} variant='outlined' color="primary" size="small">Close</Button>
                            </div>
                        </div>
                    </DialogActions>
                </Dialog>}
        </>
    )
}
export default ApproveUserModal;
